import cx from 'classnames';
import * as React from 'react';

type BadgeColor =
  | 'blue'
  | 'green'
  | 'yellow'
  | 'purple'
  | 'gray'
  | 'red'
  | 'orange'
  | 'success'
  | 'warning'
  | 'danger';

interface BadgeProps {
  children: React.ReactNode;
  color?: BadgeColor;
  small?: boolean;
  className?: string;
}

const colorClasses: Record<BadgeColor, string> = {
  // Legacy colors (for backward compatibility)
  blue: 'bg-blue-100 text-blue-800',
  green: 'bg-green-100 text-green-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  purple: 'bg-purple-100 text-purple-800',
  gray: 'bg-grey-100 text-grey-800',
  red: 'bg-red-100 text-red-800',
  // Brand colors
  orange: 'bg-coffice-orange/20 text-coffice-orange',
  success: 'bg-coffice-green/30 text-grey-900',
  warning: 'bg-coffice-yellow/30 text-grey-900',
  danger: 'bg-red-100 text-red-800',
};

export const Badge: React.FC<BadgeProps> = ({
  children,
  color = 'gray',
  small = false,
  className,
}) => {
  return (
    <span
      className={cx(
        'inline-flex items-center font-medium rounded-full',
        colorClasses[color],
        small ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-0.5 text-sm',
        className,
      )}
    >
      {children}
    </span>
  );
};
